import { __generator, __values } from "tslib";
import { delay } from 'redux-saga';
import { cancel, fork, put, select, take, cancelled } from 'redux-saga/effects';
import { uniqueId, round } from 'lodash-es';
import { EventOutcomeType, EventTriggerType } from '@marvelapp/core';
import * as actionTypes from '../constants/actionTypes';
import * as actionCreators from '../actionCreators';
import { getBrokenTransitionName } from '../utils/events';
import { imageToViewport } from '../utils/imageToViewport';
import { getCurrentScreen } from '../selectors';
import { getTransitionForTransitionToSameScreen } from '../overlayTransitions';
var MOUSE_CLICK_DURATION = 600;
function stillPlaying(events, startPosition, isPlaying) {
    var startWallTime, duration, eventIndex, seekIndex, startTime, startEventIndex, event_1, elapsedTime, timeToWaitToPlayThisEvent, eventHasTrigger, isSeeking;
    if (isPlaying === void 0) { isPlaying = true; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                startWallTime = Date.now();
                duration = events[events.length - 1].timestamp;
                seekIndex = -1;
                startTime = 0;
                if (!(startPosition !== undefined)) return [3 /*break*/, 1];
                // _compute_ the start index based on the start position
                eventIndex = 0;
                startTime = startPosition * duration;
                startTime = round(startPosition * duration);
                // Find the last event _before_ the start time. We have to rapidly replay
                // all events up to and including this one to get to the right point in the
                // replay for the _next_ event TODO binary search anyone?
                seekIndex = events.reduce(function (acc, e, i) {
                    if (e.timestamp <= startTime)
                        return i;
                    return acc;
                }, 0);
                startEventIndex = seekIndex;
                return [3 /*break*/, 3];
            case 1: return [4 /*yield*/, select(function (state) { return state.replay.currentEventIndex; })];
            case 2:
                // TODO need to adjust this as we might have paused _between_ two events
                // rather that _on_ an event
                startEventIndex = _a.sent();
                eventIndex = startEventIndex || 0;
                _a.label = 3;
            case 3:
                _a.trys.push([3, , 15, 19]);
                _a.label = 4;
            case 4:
                if (!(eventIndex < events.length)) return [3 /*break*/, 12];
                event_1 = events[eventIndex];
                elapsedTime = Math.min(Date.now() - startWallTime + startTime, event_1.timestamp);
                timeToWaitToPlayThisEvent = event_1.timestamp - elapsedTime;
                eventHasTrigger = !!event_1.trigger;
                isSeeking = eventIndex <= seekIndex;
                if (!!isSeeking) return [3 /*break*/, 8];
                if (!isPlaying) {
                    return [2 /*return*/];
                }
                if (!isPlaying) return [3 /*break*/, 6];
                return [4 /*yield*/, put(actionCreators.progress(elapsedTime / duration))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [4 /*yield*/, delay(0)];
            case 7:
                _a.sent();
                _a.label = 8;
            case 8:
                if (!(isSeeking || timeToWaitToPlayThisEvent === 0)) return [3 /*break*/, 11];
                if (!eventHasTrigger) return [3 /*break*/, 10];
                return [5 /*yield**/, __values(replayEvent(event_1, eventIndex, events, isSeeking))];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10:
                eventIndex += 1;
                _a.label = 11;
            case 11: return [3 /*break*/, 4];
            case 12: return [4 /*yield*/, put(actionCreators.progress(1))];
            case 13:
                _a.sent();
                return [4 /*yield*/, put({ type: actionTypes.REPLAY_ENDED })];
            case 14:
                _a.sent();
                return [3 /*break*/, 19];
            case 15: return [4 /*yield*/, cancelled()];
            case 16:
                if (!_a.sent()) return [3 /*break*/, 18];
                return [4 /*yield*/, put({
                        type: actionTypes.REPLAY_SET_CURRENT_EVENT,
                        eventIndex: eventIndex,
                    })];
            case 17:
                _a.sent();
                _a.label = 18;
            case 18: return [7 /*endfinally*/];
            case 19: return [2 /*return*/];
        }
    });
}
function replayEvent(event, eventIndex, events, isSeeking) {
    var transition, scrollAction, currentScreen, headerHeight, state, coords, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(actionCreators.onEvent(event, eventIndex))];
            case 1:
                _a.sent();
                if (!(event.trigger.type === EventTriggerType.Tap && !isSeeking)) return [3 /*break*/, 3];
                return [4 /*yield*/, fork(clickMouse, event)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!(event.outcome.type === EventOutcomeType.ScreenTransition)) return [3 /*break*/, 5];
                return [4 /*yield*/, put(actionCreators.showScreen(event.outcome.screen, isSeeking
                        ? undefined
                        : getBrokenTransitionName(event.outcome.animation, event.outcome.reverseAnimation), event.outcome.scrollPosition))];
            case 4:
                _a.sent();
                return [3 /*break*/, 20];
            case 5:
                if (!(event.outcome.type === EventOutcomeType.OverlayTransition)) return [3 /*break*/, 7];
                return [4 /*yield*/, put(
                    // Note the inconsistency with showScreen above -- we're passing a
                    // hotspot id to showOverlay. But what if we wanted to use showOverlay
                    // without hotspots? Really it should be more like showOverlay({
                    // screenID, position, scrollPosition, backgroundColor })
                    // NOTE we'll HAVE to do this for a public events API
                    actionCreators.showOverlay2(event.object.id, 
                    // coords,
                    event.outcome.position, 
                    // 2-D overlay scrolling not yet supported
                    event.outcome.scrollPosition[1] // TODO this needs scaled right??
                    ))];
            case 6:
                _a.sent();
                return [3 /*break*/, 20];
            case 7:
                if (!(event.outcome.type === EventOutcomeType.RemoveOverlay)) return [3 /*break*/, 9];
                transition = event.outcome.animation
                    ? getTransitionForTransitionToSameScreen(getBrokenTransitionName(event.outcome.animation))
                    : undefined;
                return [4 /*yield*/, put(actionCreators.hideOverlay(isSeeking ? undefined : transition))];
            case 8:
                _a.sent();
                return [3 /*break*/, 20];
            case 9:
                if (!(event.outcome.type === EventOutcomeType.Scroll)) return [3 /*break*/, 15];
                if (!(event.object.type === 'scrollContainer')) return [3 /*break*/, 11];
                return [4 /*yield*/, put(actionCreators.setScrollContainerScroll(event.object.id, event.outcome.coords))];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                scrollAction = event.outcome.screen || event.object.type === 'screen'
                    ? actionCreators.scrollTo
                    : actionCreators.setOverlayScrollPos;
                return [4 /*yield*/, select(getCurrentScreen)];
            case 12:
                currentScreen = _a.sent();
                headerHeight = currentScreen.header
                    ? currentScreen.header.height
                    : 0;
                return [4 /*yield*/, put(scrollAction({
                        left: event.outcome.coords[0],
                        top: event.outcome.coords[1] + headerHeight,
                    }, event.outcome.smooth))];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 20];
            case 15:
                if (!(event.trigger.type === EventTriggerType.Mousemove)) return [3 /*break*/, 20];
                return [4 /*yield*/, select(function (s) { return s; })];
            case 16:
                state = _a.sent();
                _a.label = 17;
            case 17:
                _a.trys.push([17, 19, , 20]);
                coords = imageToViewport(state, events, event.object.type, event);
                return [4 /*yield*/, put({
                        type: actionTypes.REPLAY_SET_CURSOR_POSITION,
                        coords: coords,
                    })];
            case 18:
                _a.sent();
                return [3 /*break*/, 20];
            case 19:
                e_1 = _a.sent();
                // eslint-disable-next-line no-console
                console.log('could not play event', event);
                // eslint-disable-next-line no-console
                console.trace(e_1);
                return [3 /*break*/, 20];
            case 20: return [2 /*return*/];
        }
    });
}
var playLoop; // TODO just get this from state?
export default function replayEvents() {
    var action, isPlaying;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, take([
                        actionTypes.REPLAY_START_PLAYING,
                        actionTypes.REPLAY_SEEK,
                        actionTypes.REPLAY_STOP_PLAYING,
                        actionTypes.REPLAY_ENDED,
                    ])];
            case 1:
                action = _a.sent();
                if (!(action.type === actionTypes.REPLAY_START_PLAYING ||
                    action.type === actionTypes.REPLAY_SEEK)) return [3 /*break*/, 6];
                return [4 /*yield*/, select(function (state) { return state.replay.status === 'PLAYING'; })];
            case 2:
                isPlaying = _a.sent();
                if (!playLoop) return [3 /*break*/, 4];
                return [4 /*yield*/, cancel(playLoop)];
            case 3:
                _a.sent();
                playLoop = null;
                _a.label = 4;
            case 4: return [4 /*yield*/, fork(stillPlaying, action.events, action.startPosition, action.type === actionTypes.REPLAY_START_PLAYING || isPlaying)];
            case 5:
                playLoop = _a.sent();
                return [3 /*break*/, 8];
            case 6:
                if (!(action.type === actionTypes.REPLAY_STOP_PLAYING)) return [3 /*break*/, 8];
                if (!playLoop) return [3 /*break*/, 8];
                return [4 /*yield*/, cancel(playLoop)];
            case 7:
                _a.sent();
                playLoop = null;
                _a.label = 8;
            case 8: return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
}
function clickMouse(event) {
    var clickId, coords;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                clickId = uniqueId();
                return [4 /*yield*/, select(function (state) { return state.replay.cursorCoords; })];
            case 1:
                coords = _a.sent();
                return [4 /*yield*/, put({
                        type: actionTypes.REPLAY_CLICK_START,
                        id: clickId,
                        coords: coords,
                        isMiss: event.outcome.type === EventOutcomeType.Miss,
                    })];
            case 2:
                _a.sent();
                return [4 /*yield*/, delay(MOUSE_CLICK_DURATION)];
            case 3:
                _a.sent();
                return [4 /*yield*/, put({
                        type: actionTypes.REPLAY_CLICK_END,
                        id: clickId,
                    })];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
